<div class="ir-row" *ngIf="config?.OwnerType">
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span
        ><strong>{{ 'plugins.installation-bobst-contact.owner-type' | translate }}</strong></span
      >
    </p>
  </div>
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span>{{ config?.OwnerType | ownerType }}</span>
    </p>
  </div>
</div>

<div *ngIf="technicien" class="ir-row">
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span
        ><strong>{{ 'plugins.installation-bobst-contact.team-name' | translate }}</strong></span
      >
    </p>
  </div>
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span>{{ technicien.name }}</span>
    </p>
  </div>
</div>

<ng-container *ngIf="config?.Team?.length">
  <div style="margin-top: 4em" class="ir-row">
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
      <p>
        <span
          ><strong>{{ 'plugins.installation-bobst-contact.team' | translate }}</strong></span
        >
      </p>
    </div>
    <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6"></div>
  </div>
  <table style="margin-bottom: 4em" class="ir-plugin-table optimisation-equipment">
    <tbody style="vertical-align: top">
      <tr class="th-plugin-line--subheader">
        <td width="20%">
          <span
            ><strong>{{ 'plugins.installation-bobst-contact.function' | translate }}</strong></span
          >
        </td>
        <td width="20%">
          <span
            ><strong>{{ 'plugins.installation-bobst-contact.first-name' | translate }}</strong></span
          >
        </td>
        <td width="20%">
          <span
            ><strong>{{ 'plugins.installation-bobst-contact.last-name' | translate }}</strong></span
          >
        </td>
        <td width="20%">
          <span
            ><strong>{{ 'plugins.installation-bobst-contact.phone' | translate }}</strong></span
          >
        </td>
        <td width="20%">
          <span
            ><strong>{{ 'plugins.installation-bobst-contact.email' | translate }}</strong></span
          >
        </td>
      </tr>
      <tr class="th-plugin-line--content" *ngFor="let t of config?.Team">
        <td width="20%">
          <span>{{ t?.Function | function }}</span>
        </td>
        <td width="20%">
          <span>{{ t?.Name }}</span>
        </td>
        <td width="20%">
          <span>{{ t?.LastName }}</span>
        </td>
        <td width="20%">
          <span>{{ t?.Phone }}</span>
        </td>
        <td width="20%">
          <span>{{ t?.Email }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</ng-container>

<div class="ir-row" *ngIf="config?.LocalOfficeTel">
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span
        ><strong>{{ 'plugins.installation-bobst-contact.bobst-local-telephone' | translate }}</strong></span
      >
    </p>
  </div>
  <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
    <p>
      <span>{{ config?.LocalOfficeTel }}</span>
    </p>
  </div>
</div>
